import React, { lazy } from 'react';
import registry from '~/library/store/src/registry';

const InsuranceOptionsComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "carvana-purchase-insurance-options" */ '@carvana/purchase-insurance-options'
    ) as unknown as Promise<{ default: React.ComponentType<any> }>
);

const defaultProps = {
  GetDashboardAndRouteToNextStep: (_?: boolean) => {}
};

export const InsuranceOptionsRoute = ({ GetDashboardAndRouteToNextStep } = defaultProps) => {
  return (
    <InsuranceOptionsComponent
      registry={registry}
      dashboardActions={{
        GetDashboardAndRouteToNextStep
      }}
    />
  );
};
